var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "addDisclaimer",
    attrs: {
      id: "add-disclaimer",
      "modal-dialog-scrollable": false,
      "modal-dialog-size": "lg",
    },
    on: { hidden: _vm.handleHidden, show: _vm.handleShow },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm.editing
              ? _c("span", [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.isConsent
                          ? _vm.$t("settings.disclaimers.modal.editConsent")
                          : _vm.$t("settings.disclaimers.modal.editDisclaimer")
                      ) +
                      "\n    "
                  ),
                ])
              : _c("span", [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.isConsent
                          ? _vm.$t("settings.disclaimers.modal.uploadConsent")
                          : _vm.$t(
                              "settings.disclaimers.modal.uploadDisclaimer"
                            )
                      ) +
                      "\n    "
                  ),
                ]),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c("div", { staticClass: "row no-gutters mb-3" }, [
              !_vm.editing
                ? _c("p", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.isConsent
                          ? _vm.$t("settings.disclaimers.modal.consentMessage")
                          : _vm.$t(
                              "settings.disclaimers.modal.disclaimerMessage"
                            )
                      ),
                    },
                  })
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "row no-gutters justify-content-end align-items-center mb-3",
              },
              [
                _c(
                  "material-input",
                  {
                    attrs: {
                      "label-for": "disclaimer-textarea-id",
                      label: "Disclaimer",
                      "hidden-label": true,
                      "validator-context": _vm.$v,
                    },
                    model: {
                      value: _vm.message,
                      callback: function ($$v) {
                        _vm.message = $$v
                      },
                      expression: "message",
                    },
                  },
                  [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.message,
                          expression: "message",
                        },
                      ],
                      staticClass: "form-control col-12 px-2",
                      staticStyle: {
                        "min-height": "9rem",
                        "max-height": "9rem",
                      },
                      attrs: { id: "disclaimer-textarea-id" },
                      domProps: { value: _vm.message },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.message = $event.target.value
                        },
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("input", {
                  ref: "inputFile",
                  staticClass: "d-none",
                  attrs: {
                    id: "inputfile-disclaimer-id",
                    type: "file",
                    accept:
                      "application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword,image/png,image/tiff,image/jpeg",
                  },
                  on: { input: _vm.onInputFile },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  { attrs: { for: "inputfile-disclaimer-id", hidden: "" } },
                  [_vm._v("File")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "row no-gutters",
                class:
                  _vm.isConsent || _vm.editing
                    ? "justify-content-end"
                    : "justify-content-between",
              },
              [
                !_vm.isConsent && !_vm.editing
                  ? _c("div", { staticClass: "col" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "pretty p-icon p-jelly p-primary p-round w-100 mb-2",
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.mandatory,
                                expression: "mandatory",
                              },
                            ],
                            staticClass: "mandatory-disclaimer",
                            attrs: {
                              id: "mandatory-disclaimer",
                              type: "checkbox",
                              name: "mandatoryDisclaimer",
                            },
                            domProps: {
                              checked: Array.isArray(_vm.mandatory)
                                ? _vm._i(_vm.mandatory, null) > -1
                                : _vm.mandatory,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.mandatory,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.mandatory = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.mandatory = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.mandatory = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "state p-success p-primary-alt" },
                            [
                              _c("i", { staticClass: "icon fa fa-check" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "form-check-label mandatory-disclaimer clickable",
                                  attrs: { for: "mandatory-disclaimer" },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t(
                                          "settings.disclaimers.modal.makeMandatory"
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "pretty p-icon p-jelly p-primary p-round w-100",
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.enabled,
                                expression: "enabled",
                              },
                            ],
                            staticClass: "mandatory-disclaimer",
                            attrs: {
                              id: "enable-disclaimer",
                              type: "checkbox",
                              name: "mandatoryDisclaimer",
                            },
                            domProps: {
                              checked: Array.isArray(_vm.enabled)
                                ? _vm._i(_vm.enabled, null) > -1
                                : _vm.enabled,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.enabled,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 && (_vm.enabled = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.enabled = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.enabled = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "state p-success p-primary-alt" },
                            [
                              _c("i", { staticClass: "icon fa fa-check" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "form-check-label mandatory-disclaimer clickable",
                                  attrs: { for: "enable-disclaimer" },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t(
                                          "settings.disclaimers.modal.enableDisclaimer"
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-auto align-self-center" },
                  [
                    !_vm.uploadedFile
                      ? _c(
                          "simple-button",
                          {
                            attrs: {
                              type: "primary",
                              loading: _vm.loadingFile,
                              "loading-succeeded": _vm.fileStatus,
                            },
                            on: { click: _vm.openFile },
                          },
                          [
                            _c("span", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.isConsent
                                      ? _vm.$t(
                                          "settings.disclaimers.modal.linkConsentForm"
                                        )
                                      : _vm.$t(
                                          "settings.disclaimers.modal.linkDocument"
                                        )
                                  ) +
                                  "\n          "
                              ),
                            ]),
                          ]
                        )
                      : _c("div", { staticClass: "d-flex flex-row px-3" }, [
                          _vm.file
                            ? _c(
                                "p",
                                { staticClass: "text-primary mr-3 mb-0" },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm._f("truncateText")(
                                          _vm.file.name,
                                          25
                                        )
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              )
                            : _vm.editing
                            ? _c(
                                "p",
                                { staticClass: "text-primary mr-3 mb-0" },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm._f("truncateText")(
                                          _vm.localDisclaimer.fileName,
                                          25
                                        )
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "fa fa-times clickable py-1",
                            on: { click: _vm.removeFile },
                          }),
                        ]),
                  ],
                  1
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            !_vm.editing
              ? _c(
                  "simple-button",
                  {
                    attrs: {
                      type: "primary",
                      "class-name": "btn-sm",
                      loading: _vm.loading,
                      "loading-succeeded": _vm.loadingStatus,
                      disabled: _vm.$v.$invalid,
                    },
                    on: { click: _vm.createDisclaimer },
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.$t("global.words.create")) +
                        "\n    "
                    ),
                  ]
                )
              : _c(
                  "simple-button",
                  {
                    attrs: {
                      type: "primary",
                      "class-name": "btn-sm",
                      loading: _vm.loading,
                      "loading-succeeded": _vm.loadingStatus,
                      disabled: _vm.$v.$invalid,
                    },
                    on: { click: _vm.saveCurrentDisclaimer },
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.$t("global.words.save")) +
                        "\n    "
                    ),
                  ]
                ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }